/**
 * subject-context-relationships-response.ts
 * Copyright © 2016-2018, My Coverage Plan, Inc.
 * All rights reserved.
 */

/**
 * @author Taylor DH Smith <tdsmith@safetyweb.org>
 */

import { RelationshipData }
  from "../../../subjects/relationship";
import { validateAs, validateFor, validateOpaqueID, validateTSEnum }
  from "../../validation/decorators";
import { IncomingMessage } from "../general/incoming-message";
import { MessageTag } from "../message-tag";

@validateFor(MessageTag.RSP_SUBJECT_CONTEXT_RELATIONSHIPS)
export class SubjectContextRelationshipsResponse extends IncomingMessage
{
  /** The unique tag for this message type */
  public tag : MessageTag = MessageTag.RSP_SUBJECT_CONTEXT_RELATIONSHIPS;

  /**
   * The id of the subject being described.
   * @type {number}
   */
  @validateOpaqueID()
  public subjectId : number;

  /**
   * The relationships the subject has.
   */
  @validateAs({array: "object"}) // TODO: refine
  public relationships : RelationshipData[];
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/server/messages/subjects/subject-context-relationships-response.ts